import { fileToBase64 } from '../../utils/helpers/base64';

export default function BankFileApi({ makeRequest, buildRequest, baseUrl = '' }) {

    function uploadFile(file, type) {
        return fileToBase64(file).then(base64 => {
            return buildRequest().then(function (req) {
                return makeRequest(req.post(`${baseUrl}/bankFile`, { fileName: file.name, bankFile: base64, fileType:type }));
            });
        });
    }

    function deleteFile(id) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`${baseUrl}/bankFile?BankFileId=${id}`));
        });
    }

    function getFileTypes(){
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/bankFile/types`));
        });
    }

    function getBankFiles(DateFrom, DateTo, ShowHistory = false, signal){
        const params = new URLSearchParams({
            DateFrom,
            DateTo,
            ShowHistory: ShowHistory.toString()
        });
        
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/bankFiles?${params.toString()}`, { signal }));
        });
    }


    function uploadPdfFile(file, postingDate, transactionId) {
        return fileToBase64(file).then(base64 => {
            return buildRequest().then(function (req) {
                return makeRequest(req.post(`${baseUrl}/bankFile/mcot?transactionId=${transactionId}`, { 
                    FileName: file.name, 
                    PostingDate: postingDate,
                    BankFile: base64 
                }));
            });
        });
    }

    function getSupportingDoc(id) {
        return buildRequest().then(function (req) {
            // Make request with blob response type for files
            return req.get(`${baseUrl}/bankFile/supportDocumentFile?documentId=${id}`, {
                responseType: 'blob',
            }).then(response => {
                // Extract data from response
                const data = response.data || response;
                return data;
            });
        });
    }


    function getFile(id, pdf) {
        return buildRequest().then(function (req) {
            // Make request with blob response type for files
            return req.get(`${baseUrl}/bankFile/file?BankFileId=${id}`, {
                responseType: 'blob',
            }).then(response => {
                // Extract data from response
                const data = response.data || response;
                
                // Always create a new blob with the correct MIME type
                const mimeType = pdf ? 'application/pdf' : 'text/csv';
                return new Blob([data], { type: mimeType });
            });
        });
    }



    function updateAmount(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.put(`${baseUrl}/bankFile/amount`, payload));
        });
    }

    function getNzPostFile(date) {
        const formattedDate = date instanceof Date ? date.toISOString().split('T')[0] : date;
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/bankFile/nzpost?date=${formattedDate}`));
        });
    }

    function uploadNzPostFile(fileName, contentBase64, transactionId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post(`${baseUrl}/bankFile/nzpost?transactionid=${transactionId}`, { 
                fileName: fileName, 
                bankFile: contentBase64, 
                fileType: 'NZP'
            }));
        });
    }

    function getNzPostFiles() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/bankfile/nzpost/files`));
        });
    }

    function getNzPostFileContent(filename) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/bankfile/nzpost?filename=${encodeURIComponent(filename)}`));
        });
    }

    function getCentreBankingFiles(typeId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/bankFiles?fileTypeId=${typeId}`));
        });
    }

    function uploadMerchantFile(file, bankFileId, filename) {
        return fileToBase64(file).then(base64 => {
            return buildRequest().then(function (req) {
                return makeRequest(req.post(`${baseUrl}/bankFile/merchantFile`, {
                    fileName: filename,
                    merchantFile: base64,
                    bankFileId: bankFileId
                }));
            });
        });     
    }

    function uploadWindcaveFile(file, transactionId) {
        return fileToBase64(file).then(base64 => {
            return buildRequest().then(function (req) {
                return makeRequest(req.post(`${baseUrl}/bankFile/windcave?transactionId=${transactionId}`, {
                    fileName: file.name,
                    bankFile: base64,
                    fileType: 'WIND'
                }));
            });
        });
    }

    function uploadDirectDebitFile(file, postingDate) {
        return fileToBase64(file).then(base64 => {
            return buildRequest().then(function (req) {
                return makeRequest(req.post(`${baseUrl}/bankFile/directDebit`, { 
                    FileName: file.name, 
                    filetype: 'DIR',
                    PostingDate: postingDate,
                    BankFile: base64
                }));
            });
        });
    }

    function sendCentreBankingEmails() {
        return buildRequest().then(function (req) {
            return makeRequest(req.post(`${baseUrl}/BankFile/SendCentreBankingReminderEmails`));
        });
    }

    return {
        uploadFile,
        uploadPdfFile,
        deleteFile,
        getFileTypes,
        getBankFiles,
        getNzPostFile,
        uploadNzPostFile,
        getNzPostFiles,
        getNzPostFileContent,
        getFile,
        getSupportingDoc,
        updateAmount,
        getCentreBankingFiles,
        uploadMerchantFile,
        uploadWindcaveFile,
        uploadDirectDebitFile,
        sendCentreBankingEmails
    }

}